import * as React from 'react'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import type { UseListResult } from '@ztechapps/common.hook'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { StatusEnum } from '@ztechapps/common.contract'
import { useUnitOfMeasureList } from '@ztechapps/product.common'

export type UnitOfMeasureSelectOption = {
  value: string
  label: string
  data: UnitOfMeasure
}

export function useUnitOfMeasureSelect({
  filter,
  category,
}: {
  filter?: Record<string, unknown>
  category?: string
}): UseListResult<UnitOfMeasure> & { options: UnitOfMeasureSelectOption[] } {
  const listResult = useUnitOfMeasureList({
    filter: {
      status: StatusEnum.Active,
      ...filter,
      ...(category ? { category } : {}),
    },
    sort: { category: 1, code: 1 },
  })

  const list = listResult?.list

  const options = React.useMemo(() => {
    if (isEmpty(list)) return []

    return map(list, (item) => ({
      value: item._id,
      label: `${item.name} (${item.symbol})`,
      data: item,
    }))
  }, [list])

  return {
    ...listResult,
    options,
  }
}

export function useUnitOfMeasureSelectOptions<T = UnitOfMeasureSelectOption>({
  filter,
  category,
}: {
  filter?: Record<string, unknown>
  category?: string
}) {
  const { options } = useUnitOfMeasureSelect({ filter, category })

  return (options ?? []) as T[]
}
